<template>
  <div>
    <channel-field class="mb-3">
      <div slot="label">Public Account Name:</div>
      <div slot="value">{{ channel.viber.name }}</div>
    </channel-field>
    <channel-field class="mb-3">
      <div slot="label">Category:</div>
      <div slot="value">{{ channel.viber.category }}</div>
    </channel-field>
    <channel-field class="mb-3">
      <div slot="label">URI:
        <span id="uri_info" v-b-popover:uri_info.html.hover.right="uriPopoverText">
          <icon name="info-circle"></icon>
        </span>
      </div>
      <div slot="value">{{ channel.viber.uri }}</div>
    </channel-field>
    <channel-field class="mb-3 align-items-center">
      <div slot="label">App Key:
      </div>
      <div slot="value">
        <sensitive-field :text="channel.viber.access_token" readonly/>
      </div>
    </channel-field>
  </div>
</template>

<script>
  import ChannelDetailField from '@/components/administration/common/Field'
  import 'vue-awesome/icons/info-circle'
  import SensitiveField from '@/components/common/SensitiveField'

  const uriPopoverText = 'Use this URI for Viber links, see ' +
    '<a href="https://docs.amio.io/docs/viber-entry-points-bot-links" target="_blank">documentation</a>' +
    ' for more details.'

  export default {
    components: {
      SensitiveField,
      'channel-field': ChannelDetailField
    },

    store: {
      channel: 'administration.channelDetail.channel'
    },

    data() {
      return {
        uriPopoverText
      }
    }
  }
</script>
